// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"n2-z","displaySixCardTiles":"o2-z"};